<script>
    import { createEventDispatcher } from 'svelte';
    import { Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    export let location = {id: 0, name: '', description: '', levels: 0, levelPositions: 0};
    let value;
    let shown = false;
    let authenthicationData = '';

    export function show() {
        shown = true;
    }
    function hide() {
        shown = false;
    }

    let onChange = () => {};
    
    async function _onOkay() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'POST';
        if(location.id != 0) {
            method = 'PUT';
        }

        location.levels = parseInt(location.levels);
        location.levelPositions = parseInt(location.levelPositions);
        

        const response = await fetch(
            'MYURL/location',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    location
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }
    
    function _onCancel() {
        location = {id: 0, name: '', description: '', levels: 0, levelPositions: 0};
        hide();
    }
    
    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="cruLocation">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>
            {#if location.id === 0}
                <h2>Neuer Standort/Raum</h2>
            {:else}
                <h2>Standort/Raum bearbeiten</h2>
            {/if}
            <h3>Name</h3>
            <input class="textbox" bind:value={location.name} />
            <h3>Beschreibung</h3>
            <textarea class="textboxMultiLine" bind:value={location.description} />
            <h3>Anzahl Etagen</h3>
            <input class="textbox" bind:value={location.levels} />
            <h3>Positionen pro Etage</h3>
            <input class="textbox" bind:value={location.levelPositions} />
            
            <div>
                <div class="buttons">
                    <button on:click={() => _onOkay()}>
                        Speichern
                    </button>
                    <button on:click={_onCancel}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }
    .textboxMultiLine {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
        min-height: 70px;
    }

    .buttons {
        float: right;
    }

	.cruLocation {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
        .cruLocation {
            background: rgb(0, 0, 0);
            background: rgba(0, 0, 0, 0.6);
            position: fixed;
            width: 98%;
            height: 100%;
            top: 0;
            left: 0;
            overflow-y: scroll;
            padding: 3rem 1%;
            flex-direction: column;
        }
        
        .textbox {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
        }
        
        .textboxMultiLine {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
            min-height: 100px;
        }
    }
</style>